<style src="../assets/estilo-dashboard.css"></style>
<style src="../assets/estilo-dashboard-2.css"></style>

<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm12 md12>
                <!--v-card class="elevation-12"-->
                    <v-toolbar dark color="primary">
                        <v-toolbar-title><a href="javascript:history.back()" class="voltar"><img class="imgVoltar" :src="imgVoltar"></a>Dashboard do aluno</v-toolbar-title>
                    </v-toolbar>
                    <br />
                    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                        <div class="md-card md-theme-default">
                            <div class="md-card-header card-chart" @click="diario" data-background-color="blue">
                                <div id="div_1113761961257" class="ct-chart">
                                    <img class="imgDiario" :src="imgDiario">
                                </div>
                            </div>
                            <div class="md-card-content">
                                <h4 @click="diario" class="title">Diário</h4>
                                <p class="category">Detalhe do dia da criança</p>
                            </div>
                            <!-- <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <i class="md-icon md-icon-font md-theme-default">access_time</i>
                                    updated 10 days ago
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                        <div class="md-card md-theme-default">
                            <div class="md-card-header card-chart" @click="diarioTimeline" data-background-color="green">
                                <div id="div_1113761961257" class="ct-chart">
                                    <img class="imgResumoMensal" :src="imgResumoMensal">
                                </div>
                            </div>
                            <div class="md-card-content">
                                <h4 @click="diarioTimeline" class="title">Resumo Mensal</h4>
                                <p class="category">Resumo do mês</p>
                            </div>
                            <!-- <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <i class="md-icon md-icon-font md-theme-default">access_time</i>
                                    updated 10 days ago
                                </div>
                            </div> -->
                        </div>
                    </div>

            </v-flex>
            
        </v-layout>

        

        <v-dialog v-model="dialogDiario" max-width="100%">
            
            <v-card>
                
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                
                <v-card-text>
                    <v-layout row wrap>
                        <a class="closeModal" @click="closeModal">x</a>
                        <v-flex xs11 sm5>
                            <v-menu
                            lazy
                            :close-on-content-click="false"
                            v-model="menu"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            max-width="290px"
                            min-width="290px"
                            >
                            <v-text-field
                                slot="activator"
                                label="Data"
                                v-model="date"
                                prepend-icon="event"
                                readonly
                            ></v-text-field>
                            <v-date-picker v-model="date" no-title scrollable actions>
                                <!--template scope="{ save, cancel }"-->
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <!--v-btn flat color="primary" @click="cancel">Cancel</v-btn-->
                                    <v-btn class="buttonOk" flat color="primary" @click="diarioPorData">OK</v-btn>
                                </v-card-actions>
                                <!--/template-->
                            </v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>



                    <v-card v-if="resumo == true">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Diário do(a) {{nomeAluno}}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>

                            
                            <v-flex xs6 sm6 md6 style="float:left; padding-right:6px">
                                <v-text-field disabled name="entrada" placeholder="00:00" v-mask="'##:##'" label="Entrada" type="text"
                                                v-model="entrada">
                                </v-text-field><br />
                            </v-flex>
                            <v-flex xs6 sm6 md6 style="float:right; padding-left:6px">
                                <v-text-field disabled name="saida" placeholder="00:00" v-mask="'##:##'" label="Saída" type="text"
                                                v-model="saida">
                                </v-text-field><br />
                            </v-flex>
                            <label class="v-label theme--light">Como estou hoje:</label>
                            <template>
                                <v-layout>
                                    <v-flex xs12 sm6 offset-sm3>
                                    
                                        <v-container grid-list-sm fluid>
                                        <v-layout row wrap layout align-center justify-center ma-0 custom-rating>
                                            <v-flex xs2>
                                                <label class="label-rating">Ótimo</label>
                                                <a class="layout row wrap layout align-center justify-center ma-0" @click="emogiRate('1')">
                                                    <img :src="img1" />
                                                </a>
                                                    
                                            </v-flex>
                                            <v-flex xs2>
                                                <label class="label-rating">Bem</label>
                                                <a class="layout row wrap layout align-center justify-center ma-0" @click="emogiRate('2')">
                                                    <img :src="img2" />
                                                </a>
                                                    
                                            </v-flex>
                                            <v-flex xs2>
                                                <label class="label-rating">Ruim</label>
                                                <a class="layout row wrap layout align-center justify-center ma-0" @click="emogiRate('4')">
                                                    <img :src="img4" />
                                                </a>
                                                    
                                            </v-flex>
                                            <v-flex xs2>
                                                <label class="label-rating">Doente</label>
                                                <a class="layout row wrap layout align-center justify-center ma-0" @click="emogiRate('5')">
                                                    <img :src="img5" />
                                                </a>
                                                    
                                            </v-flex>
                                        </v-layout>
                                        </v-container>
                                    
                                    </v-flex>
                                </v-layout>
                            </template><br />
                                   
                            <v-text-field disabled name="horasSono" placeholder="00:00" v-mask="'##:##'" label="Horas de sono" type="text"
                                            v-model="horasSono">
                            </v-text-field>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsCafeManha"
                                        item-value="value.cafeManhaID"
                                        item-text="value.cafeManhaName"
                                        label="Café da manha"
                                        return-object
                                        v-model="cafeManha"
                                        disabled
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsAlmoco"
                                        item-value="value.almocoID"
                                        item-text="value.almocoName"
                                        label="Almoço"
                                        return-object
                                        v-model="almoco"
                                        disabled
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsCafeTarde"
                                        item-value="value.cafeTardeID"
                                        item-text="value.cafeTardeName"
                                        label="Café da tarde"
                                        return-object
                                        v-model="cafeTarde"
                                        disabled
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsJanta"
                                        item-value="value.jantaID"
                                        item-text="value.jantaName"
                                        label="Jantar"
                                        return-object
                                        v-model="janta"
                                        disabled
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsEvacuacao"
                                        item-value="value.evacuacaoID"
                                        item-text="value.evacuacaoName"
                                        label="Evacuação"
                                        return-object
                                        v-model="evacuacao"
                                        disabled
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-card-text style="padding:0 0 0 0; width:100%"> 
                                    <v-select
                                        :items="itemsfrauda"
                                        item-value="value.fraudaID"
                                        item-text="value.fraudaName"
                                        label="Fraudas"
                                        return-object
                                        v-model="frauda"
                                        disabled
                                    ></v-select>
                                </v-card-text>
                            </v-flex>

                            <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-switch
                                        v-model="licaoCasa"
                                        :label="`Lição de casa:`"
                                        disabled
                                    ></v-switch>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-switch
                                        v-model="banho"
                                        :label="`Banho:`"
                                        disabled
                                    ></v-switch>
                                </v-flex>
                            </v-layout>

                           

                            
                            
                        </v-form>
                    </v-card-text>
                    <!--v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn>
                        <v-btn color="primary" :disabled="!valid || !statusUpload" @click="atualizarResumoDiario" data-cy="joinSubmitBtn">Atualizar</v-btn>
                    </v-card-actions-->
                </v-card>



                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>


                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>







        <v-dialog v-model="dialogDiarioTimeline" max-width="100%">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <v-toolbar-title>Resumo mensal do(a) {{nomeAluno}}</v-toolbar-title>
                <v-card-text>
                    <label class="v-label theme--light">Ano:</label>
                    <v-flex xs12 sm12 md12>
                        <v-card-text style="padding:0 0 0 0; width:100%"> 
                            <v-select
                                :items="itemsAnos"
                                item-value="value.ID"
                                item-text="value.label"
                                return-object
                                v-model="anos"
                                v-on:change="changeYear"
                            ></v-select>
                        </v-card-text>
                    </v-flex><br />

                    <label class="v-label theme--light">Mês:</label>
                    <v-flex xs12 sm12 md12>
                        <v-card-text style="padding:0 0 0 0; width:100%"> 
                            <v-select
                                :items="itemsMeses"
                                item-value="value.ID"
                                item-text="value.label"
                                return-object
                                v-model="meses"
                                v-on:change="changeMonth"
                            ></v-select>
                        </v-card-text>
                    </v-flex><br />
                    
                    <v-card>
                    
                    
                        <!--v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn>
                            <v-btn color="primary" :disabled="!valid || !statusUpload" @click="atualizarResumoDiario" data-cy="joinSubmitBtn">Atualizar</v-btn>
                        </v-card-actions-->
                    </v-card>
                        <a class="closeModal" @click="closeModal">x</a>
                        <div>
                            <v-radio-group row wrap style="display:none">
                            <v-switch v-model="alignTop" label="Toggle align-top" class="mx-4"></v-switch>
                            <v-switch v-model="dense" label="Toggle dense" class="mx-4"></v-switch>
                            <v-switch v-model="fillDot" label="Toggle fill-dot" class="mx-4"></v-switch>
                            <v-switch v-model="hideDot" label="Toggle hide-dot" class="mx-4"></v-switch>
                            <v-switch v-model="icon" label="Toggle icon" class="mx-4"></v-switch>
                            <v-switch v-model="avatar" label="Toggle avatar" class="mx-4"></v-switch>
                            <v-switch v-model="iconColor" label="Toggle icon color" class="mx-4"></v-switch>
                            <v-switch v-model="reverse" label="Toggle reverse" class="mx-4"></v-switch>
                            <v-switch v-model="left" label="Toggle left" class="mx-4"></v-switch>
                            <v-switch v-model="right" label="Toggle right" class="mx-4"></v-switch>
                            <v-switch v-model="small" label="Toggle small" class="mx-4"></v-switch>
                            </v-radio-group>

                            <div id="chart" v-if="resumo == true">
                                <apexchart type=pie width=380 :options="chartOptions" :series="series" />
                            </div>
                            <br /><br />
                            <h2 v-if="resumo == true">Timeline</h2>
                            <v-timeline
                            :align-top="alignTop"
                            :dense="dense"
                            :reverse="reverse"
                            v-if="resumo == true">
                            <v-timeline-item style="height:60px" v-for="(item, index) in objTimeline"
                                :key="n"
                                :fill-dot="fillDot"
                                :hide-dot="hideDot"
                                :icon="icon ? 'mdi-star' : ''"
                                :icon-color=" iconColor ? 'deep-orange' : ''"
                                :left="left"
                                :right="right"
                                :small="small"
                            >
                                <template v-slot:icon>
                                <v-avatar>
                                    <img :src="img1" v-if="item.rating == 1">
                                    <img :src="img2" v-if="item.rating == 2">
                                    <img :src="img3" v-if="item.rating == 3">
                                    <img :src="img4" v-if="item.rating == 4">
                                    <img :src="img5" v-if="item.rating == 5">
                                </v-avatar>
                                </template>
                                <v-card class="elevation-2">
                                <v-card-title class="headline" style="margin-bottom:0; padding-bottom:0">{{item.data}}</v-card-title>
                                <v-card-text style="margin-top:0; padding-top:0" :v-if="item.observacao != ''">
                                    {{item.observacao}}
                                </v-card-text>
                                </v-card>
                            </v-timeline-item>
                            </v-timeline>
                        </div>

                    </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>


                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>









        <v-dialog v-model="engajamento" max-width="100%">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <v-toolbar-title>Meu engajamento</v-toolbar-title>
                <v-card-text>
                    <label class="v-label theme--light">Ano:</label>
                    <v-flex xs12 sm12 md12>
                        <v-card-text style="padding:0 0 0 0; width:100%"> 
                            <v-select
                                :items="itemsAnos"
                                item-value="value.ID"
                                item-text="value.label"
                                return-object
                                v-model="anos"
                                v-on:change="changeYear2"
                            ></v-select>
                        </v-card-text>
                    </v-flex><br />

                    <label class="v-label theme--light">Mês:</label>
                    <v-flex xs12 sm12 md12>
                        <v-card-text style="padding:0 0 0 0; width:100%"> 
                            <v-select
                                :items="itemsMeses"
                                item-value="value.ID"
                                item-text="value.label"
                                return-object
                                v-model="meses"
                                v-on:change="changeMonth2"
                            ></v-select>
                        </v-card-text>
                    </v-flex><br />
                    
                    <v-card>
                    
                    
                        <!--v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn>
                            <v-btn color="primary" :disabled="!valid || !statusUpload" @click="atualizarResumoDiario" data-cy="joinSubmitBtn">Atualizar</v-btn>
                        </v-card-actions-->
                    </v-card>
                        <a class="closeModal" @click="closeModal">x</a>
                        <div>
                            <v-radio-group row wrap style="display:none">
                            <v-switch v-model="alignTop" label="Toggle align-top" class="mx-4"></v-switch>
                            <v-switch v-model="dense" label="Toggle dense" class="mx-4"></v-switch>
                            <v-switch v-model="fillDot" label="Toggle fill-dot" class="mx-4"></v-switch>
                            <v-switch v-model="hideDot" label="Toggle hide-dot" class="mx-4"></v-switch>
                            <v-switch v-model="icon" label="Toggle icon" class="mx-4"></v-switch>
                            <v-switch v-model="avatar" label="Toggle avatar" class="mx-4"></v-switch>
                            <v-switch v-model="iconColor" label="Toggle icon color" class="mx-4"></v-switch>
                            <v-switch v-model="reverse" label="Toggle reverse" class="mx-4"></v-switch>
                            <v-switch v-model="left" label="Toggle left" class="mx-4"></v-switch>
                            <v-switch v-model="right" label="Toggle right" class="mx-4"></v-switch>
                            <v-switch v-model="small" label="Toggle small" class="mx-4"></v-switch>
                            </v-radio-group>

                            <div id="chart" v-if="resumo == true">
                                <apexchart type=pie width=380 :options="chartOptions" :series="series" />
                            </div>
                            <br /><br />
                            <h2 v-if="resumo == true">Timeline</h2>
                            <v-timeline
                            :align-top="alignTop"
                            :dense="dense"
                            :reverse="reverse"
                            v-if="resumo == true">
                            <v-timeline-item v-for="(item, index) in objTimeline"
                                :key="n"
                                :fill-dot="fillDot"
                                :hide-dot="hideDot"
                                :icon="icon ? 'mdi-star' : ''"
                                :icon-color=" iconColor ? 'deep-orange' : ''"
                                :left="left"
                                :right="right"
                                :small="small"
                            >
                                <template v-slot:icon>
                                <v-avatar>
                                    <img :src="img1" v-if="item.rating == 1">
                                    <img :src="img2" v-if="item.rating == 2">
                                    <img :src="img3" v-if="item.rating == 3">
                                    <img :src="img4" v-if="item.rating == 4">
                                    <img :src="img5" v-if="item.rating == 5">
                                </v-avatar>
                                </template>
                                <v-card class="elevation-2">
                                <v-card-title class="headline" style="margin-bottom:0; padding-bottom:0">{{item.data}}</v-card-title>
                                <v-card-text style="margin-top:0; padding-top:0" :v-if="item.observacao != ''">
                                    {{item.observacao}}
                                </v-card-text>
                                </v-card>
                            </v-timeline-item>
                            </v-timeline>
                        </div>

                    </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>


                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
    </v-container>
</template>

<script>
import Vue from 'vue'
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask';

import { userProperties, usersData } from '@/global.js';

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
 
Vue.component('apexchart', VueApexCharts)


import img1 from '../assets/muito-feliz.png';
import img2 from '../assets/feliz.png';
import img3 from '../assets/normal.png';
import img4 from '../assets/ruim.png';
import img5 from '../assets/muito-ruim.png';

import imgDiario from '../assets/ic-diario.png';
import imgResumoMensal from '../assets/ic-resumo-mensal.png';

import imgVoltar from '../assets/ic-voltar.png';

var now = new Date();
var year = "" + now.getFullYear();
var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }

export default {
    name: 'Dashboard-Aluno',
    components: {
        apexchart: VueApexCharts,
    },
    directives: {mask},
    data: vm => ({
        imgVoltar: imgVoltar,
        img1: img1,
        img2: img2,
        img3: img3,
        img4: img4,
        img5: img5,
        imgDiario: imgDiario,
        imgResumoMensal: imgResumoMensal,
        //varivaveis da timeline
        alignTop: true,
        avatar: false,
        dense: true,
        fillDot: false,
        hideDot: false,
        icon: false,
        iconColor: false,
        left: false,
        reverse: false,
        right: true,
        small: false,
        anoSelecionado: year,
        mesSelecionado: month,
        engajamento: false,
        anos: {
            value: {
                ID: year,
                label: year
            }//,
        //text: '2018'
        },
        itemsAnos: [
            {
                value: {
                    ID: '2018',
                    label: '2018'
                }//,
                //text: '2018'
            },
            {
                value: {
                    ID: '2019',
                    label: '2019'
                }
                //text: '2019'
            },
            {
                value: {
                    ID: '2020',
                    label: '2020'
                }
                //text: '2019'
            }
        ],
        meses: {
            value: {
                ID: month
            }//,
        //text: '2018'
        },
        itemsMeses: [
            {
                value: {
                    ID: '00',
                    label: 'Todos'
                }
            },
            {
                value: {
                    ID: '01',
                    label: 'Janeiro'
                }
            },
            {
                value: {
                    ID: '02',
                    label: 'Fevereiro'
                }
            },
            {
                value: {
                    ID: '03',
                    label: 'Março'
                }
            },
            {
                value: {
                    ID: '04',
                    label: 'Abril'
                }
            },
            {
                value: {
                    ID: '05',
                    label: 'Maio'
                }
            },
            {
                value: {
                    ID: '06',
                    label: 'Junho'
                }
            },
            {
                value: {
                    ID: '07',
                    label: 'Julho'
                }
            },
            {
                value: {
                    ID: '08',
                    label: 'Agosto'
                }
            },
            {
                value: {
                    ID: '09',
                    label: 'Setembro'
                }
            },
            {
                value: {
                    ID: '10',
                    label: 'Outubro'
                }
            },
            {
                value: {
                    ID: '11',
                    label: 'Novembro'
                }
            },
            {
                value: {
                    ID: '12',
                    label: 'Dezembro'
                }
            }
        ],

        objTimeline: [],
        rating: null,
        executaUmaVez: 0,
        valid: false,
        loading: false,
        dialogDiario: false,
        dialogDiarioTimeline: false,
        tituloModal: "Selecione o período!",
        menu: false,
        chartsLib: null,
        date: new Date().toISOString().substr(0, 10),
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        licaoCasa: false,
        pushIDs: null,
        banho: false,
        textoPush: null,
        entrada: null,
        saida: null,
        horasSono: null,
        nomeAluno: null,
                evacuacao: {
                        value: {
                            evacuacaoID: 0,
                            evacuacaoName: 'Nenhuma vez'
                        }
                    },
                itemsEvacuacao: [
                    {
                        value: {
                            evacuacaoID: 0,
                            evacuacaoName: 'Nenhuma vez' // Aparece na timeline e na listagem
                        },
                        text: 'Nenhuma vezv'
                    },
                    {
                        value: {
                            evacuacaoID: 1,
                            evacuacaoName: 'Um vez' // Aparece na timeline e na listagem
                        },
                        text: 'Um vez'
                    },
                    {
                        value: {
                            evacuacaoID: 2,
                            evacuacaoName: 'Duas vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Duas vezes'
                    },
                    {
                        value: {
                            evacuacaoID: 3,
                            evacuacaoName: 'Três vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Três vezes'
                    }
                    ,
                    {
                        value: {
                            evacuacaoID: 4,
                            evacuacaoName: 'Mais de 3 vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Mais de 3 vezes'
                    }
                ],
                frauda: {
                    value: {
                        fraudaID: 0,
                        fraudaName: 'Nenhuma vez'
                    }
                },
                itemsFrauda: [
                    {
                        value: {
                            fraudaID: 0,
                            fraudaName: 'Nenhuma vez'
                        },
                        text: 'Nenhuma vezv'
                    },
                    {
                        value: {
                            fraudaID: 1,
                            fraudaName: 'Um vez' // Aparece na timeline e na listagem
                        },
                        text: 'Um vez'
                    },
                    {
                        value: {
                            fraudaID: 2,
                            fraudaName: 'Duas vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Duas vezes'
                    },
                    {
                        value: {
                            fraudaID: 3,
                            fraudaName: 'Três vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Três vezes'
                    },
                    {
                        value: {
                            fraudaID: 4,
                            fraudaName: 'Quatro vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Quatro vezes'
                    },
                    {
                        value: {
                            fraudaID: 5,
                            fraudaName: 'Cinco vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Cinco vezes'
                    },
                    {
                        value: {
                            fraudaID: 6,
                            fraudaName: 'Seis vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Seis vezes'
                    },
                    {
                        value: {
                            fraudaID: 7,
                            fraudaName: 'Sete vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Sete vezes'
                    },
                    {
                        value: {
                            fraudaID: 8,
                            fraudaName: 'Oito vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Oito vezes'
                    },
                    {
                        value: {
                            fraudaID: 9,
                            fraudaName: 'Nove vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Nove vezes'
                    },
                    {
                        value: {
                            fraudaID: 10,
                            fraudaName: 'Dez vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Dez vezes'
                    },
                    {
                        value: {
                            fraudaID: 11,
                            fraudaName: 'Mais de 10 vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Mais de 10 vezes'
                    }
                ],
                cafeManha: {
                    value: {
                        cafeManhaID: 0,
                        cafeManhaName: 'Não'
                    }
                },
                itemsCafeManha: [
                    {
                        value: {
                            cafeManhaID: 0,
                            cafeManhaName: 'Não' // Aparece na timeline e na listagem
                        },
                        text: 'Não'
                    },
                    {
                        value: {
                            cafeManhaID: 1,
                            cafeManhaName: 'Sim' // Aparece na timeline e na listagem
                        },
                        text: 'Sim'
                    }
                ],
                almoco: {
                    value: {
                        almocoID: 0,
                        almocoName: 'Não'
                    }
                },
                itemsAlmoco: [
                    {
                        value: {
                            almocoID: 0,
                            almocoName: 'Não'
                        },
                        text: 'Não'
                    },
                    {
                        value: {
                            almocoID: 1,
                            almocoName: 'Sim'
                        },
                        text: 'Sim'
                    }
                ],
                cafeTarde: {
                    value: {
                        cafeTardeID: 0,
                        cafeTardeName: 'Não'
                    }
                },
                itemsCafeTarde: [
                    {
                        value: {
                            cafeTardeID: 0,
                            cafeTardeName: 'Não' 
                        },
                        text: 'Não'
                    },
                    {
                        value: {
                            cafeTardeID: 1,
                            cafeTardeName: 'Sim'
                        },
                        text: 'Sim'
                    }
                ],
                janta: {
                    value: {
                        jantaID: 0,
                        jantaName: 'Não'
                    }
                },
                itemsJanta: [
                    {
                        value: {
                            jantaID: 0,
                            jantaName: 'Não' 
                        },
                        text: 'Não'
                    },
                    {
                        value: {
                            jantaID: 1,
                            jantaName: 'Sim'
                        },
                        text: 'Sim'
                    }
                ],
                aluno: {
                        alunoSlug: '',
                        alunoName: ''
                },
                itemsAlunos: [
                    // {
                    //         alunoSlug: 0,
                    //         alunoName: 'Laura'
                    // },
                    // {
                    //         alunoSlug: 1,
                    //         alunoName: 'Alice'
                    // }
                ],
                resumo: false,
                otimo: 0,
                bom: 0,
                normal: 0,
                ruim: 0,
                regular: 0,
                series: [44, 55, 13, 43, 22],
                colors: ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
                chartOptions: {
                    labels: ['Ótimo', 'Bem', 'Normal', 'Ruim', 'Doente'],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 300
                            },
                            legend: {
                                position: 'bottom'
                                
                            }
                        }
                    }]
                }
        
    }),
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        changeYear(selected){
            console.log("Ano Selecionado = " + selected.value.ID);
            this.anoSelecionado = selected.value.ID;
            this.diarioTimeline();
        },
        changeMonth(selected){
            console.log("Mes Selecionado = " + selected.value.ID);
            this.mesSelecionado = selected.value.ID;
            if(selected.value.label == "Todos"){
                this.diarioTimelineTodos();
            }                
            else{
                this.diarioTimeline();
            }
        },
        changeYear2(selected){
            console.log("Ano Selecionado = " + selected.value.ID);
            this.anoSelecionado = selected.value.ID;
            this.meuEngajamento();
        },
        changeMonth2(selected){
            console.log("Mes Selecionado = " + selected.value.ID);
            this.mesSelecionado = selected.value.ID;
            this.meuEngajamento();
        },
        meuEngajamento(){
            this.engajamento = true;
        },
        diarioPorData(){

            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'dashboard responsaveis',
                'event_label': 'diario por data'//,
                //'value': '<value>'
            });

            this.menu = false;
            var that = this;
            this.loading = true;

            // Busca nome pelo Sllug
            //var responsaveisDoAlunoSlug = [];
            usersData.usuarios.forEach((item, index) => {
                if(item.slug == this.$route.query.slug){
                    this.nomeAluno = item.nome;
                }
            });

            db.collection('resumodiario_'+userProperties.escolaID).where("aluno.alunoSlug", "==", this.$route.query.slug).where("date", "==", this.date)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    this.resumo = false
                    alert("O aluno(a) não possui registro nesse período.")
                }
                else{
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());       
                        let customObj = doc.data()
                        this.date = customObj.date,
                        this.entrada = customObj.entrada,
                        this.saida = customObj.saida,
                        this.horasSono = customObj.horasSono,
                        this.evacuacao = {
                            value: {
                                evacuacaoID: customObj.evacuacaoID,
                                evacuacaoName: customObj.evacuacaoName
                            }
                        },
                        this.frauda = {
                            value: {
                                fraudaID: customObj.fraudaID,
                                fraudaName: customObj.fraudaName
                            }
                        },
                        // this.evacuacao.value.evacuacaoName = customObj.evacuacaoName,
                        // this.evacuacao.value.evacuacaoID = customObj.evacuacaoID,
                        this.cafeManha = {
                            value: {
                                cafeManhaID: customObj.cafeManhaID,
                                cafeManhaName: customObj.cafeManhaName
                            }
                        },
                        // this.cafeManha.value.cafeManhaName = customObj.cafeManhaName,
                        // this.cafeManha.value.cafeManhaID = customObj.cafeManhaID,
                        this.almoco = {
                            value: {
                                almocoID: customObj.almocoID,
                                almocoName: customObj.almocoName
                            }
                        },
                        // this.almoco.value.almocoName = customObj.almocoName,
                        // this.almoco.value.almocoID = customObj.almocoID,
                        this.cafeTarde = {
                            value: {
                                cafeTardeID: customObj.cafeTardeID,
                                cafeTardeName: customObj.cafeTardeName
                            }
                        },
                        // this.cafeTarde.value.cafeTardeName = customObj.cafeTardeName,
                        // this.cafeTarde.value.cafeTardeID = customObj.cafeTardeID,
                        this.janta = {
                            value: {
                                jantaID: customObj.jantaID,
                                jantaName: customObj.jantaName
                            }
                        },
                        // this.janta.value.jantaName = customObj.jantaName,
                        // this.janta.value.jantaID = customObj.jantaID,
                        this.licaoCasa = customObj.licaoCasa,
                        this.banho = customObj.banho,
                        this.rating = customObj.rating,
                        this.aluno = customObj.aluno,
                        this.alunoName = "customObj.alunoName"
                    });
                    this.resumo = true
                }
                that.executaUmaVez = 0;
                setTimeout(function(){ 
                    
                    $(".custom-rating a").click(function(){
                        if(that.executaUmaVez == 0){
                            $(".custom-rating a").removeClass("selected");
                            $(this).addClass("selected");
                            that.executaUmaVez = 1;
                        }
                    })    
                    // Marca carinha/rating selecionada
                    var itemRating = Number(that.rating) - 1;
                    $(".custom-rating a:eq("+itemRating+")").click();    

                }, 500);

                this.loading = false;
                
            })
            .catch((err) => {
                console.log("ERRO AO CONSULTAR DIÁRIO: ", err);
                this.resumo = false;
                alert("Erro ao consultar diário.")
            })

        },
        closeModal(){
            this.dialogDiario = false;
            this.dialogDiarioTimeline = false;
            this.loading = false;
        },
        onChartReady (chart, google) {
            this.chartsLib = google
        },
        diario(){
            this.dialogDiario = true;
        },
        diarioTimeline(){

            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'dashboard responsaveis',
                'event_label': 'timeline'//,
                //'value': '<value>'
            });

            this.dialogDiarioTimeline = true;
            this.loading = true;
            this.resumo = false;

            this.objTimeline = [];

            // ordernar exibicao - numerica
            function ordenarPorTimestamp(a, b){
                //return a.dataNumero - b.dataNumero; // crescente
                return b.dataNumero - a.dataNumero; // decrescente
            }

            db.collection('resumodiario_'+userProperties.escolaID).where("aluno.alunoSlug", "==", this.$route.query.slug).where("ano", "==", this.anoSelecionado).where("mes", "==", this.mesSelecionado)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    this.resumo = false
                    alert("O aluno(a) não possui registro nessa data.")
                }
                else{
                    var otimo = 0; // 1
                    var bom = 0;  // 2
                    var normal = 0; // 3
                    var ruim = 0; // 4
                    var doente = 0; // 5
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());       
                        
                        let customObj = doc.data()
                        this.date = customObj.date,
                        this.rating = customObj.rating
                        if(customObj.rating == 1){
                            otimo = otimo + 1
                        }
                        if(customObj.rating == 2){
                            bom = bom + 1
                        }
                        if(customObj.rating == 3){
                            normal = normal + 1
                        }
                        if(customObj.rating == 4){
                            ruim = ruim + 1
                        }
                        if(customObj.rating == 5){
                            doente = doente + 1
                        }
                        this.objTimeline.push({"data":customObj.date.substring(8,10) + "-" + customObj.date.substring(5,7) + "-" + customObj.date.substring(0,4), "rating":customObj.rating, "dataNumero":customObj.date.replace(/-/g, ''), "observacao":customObj.observacao})
                    });
                    this.otimo = otimo; // 1
                    this.bom = bom;  // 2
                    this.normal = normal; // 3
                    this.ruim = ruim; // 4
                    this.doente = doente; // 5

                    this.resumo = true;

                    this.series = [this.otimo, this.bom, this.normal, this.ruim, this.doente];
                }

                this.objTimeline.sort(ordenarPorTimestamp)

                this.loading = false;
            
            })
            .catch((err) => {
                console.log("ERRO AO CONSULTAR DIÁRIO: ", err);
                this.loading = false;
                this.resumo = false;
                alert("Erro ao consultar diário.")
            })
        },
        diarioTimelineTodos(){
            this.dialogDiarioTimeline = true;
            this.loading = true;
            this.resumo = false;

            this.objTimeline = [];

            // ordernar exibicao - numerica
            function ordenarPorTimestamp(a, b){
                //return a.dataNumero - b.dataNumero; // crescente
                return b.dataNumero - a.dataNumero; // decrescente
            }

            db.collection('resumodiario_'+userProperties.escolaID).where("aluno.alunoSlug", "==", this.$route.query.slug).where("ano", "==", this.anoSelecionado)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    this.resumo = false
                    alert("O aluno(a) não possui registro nessa data.")
                }
                else{
                    var otimo = 0; // 1
                    var bom = 0;  // 2
                    var normal = 0; // 3
                    var ruim = 0; // 4
                    var doente = 0; // 5
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());       
                        
                        let customObj = doc.data()
                        this.date = customObj.date,
                        this.rating = customObj.rating
                        if(customObj.rating == 1){
                            otimo = otimo + 1
                        }
                        if(customObj.rating == 2){
                            bom = bom + 1
                        }
                        if(customObj.rating == 3){
                            normal = normal + 1
                        }
                        if(customObj.rating == 4){
                            ruim = ruim + 1
                        }
                        if(customObj.rating == 5){
                            doente = doente + 1
                        }
                        this.objTimeline.push({"data":customObj.date.substring(8,10) + "-" + customObj.date.substring(5,7) + "-" + customObj.date.substring(0,4), "rating":customObj.rating, "dataNumero":customObj.date.replace(/-/g, ''), "observacao":customObj.observacao})
                    });
                    this.otimo = otimo; // 1
                    this.bom = bom;  // 2
                    this.normal = normal; // 3
                    this.ruim = ruim; // 4
                    this.doente = doente; // 5

                    this.resumo = true;

                    this.series = [this.otimo, this.bom, this.normal, this.ruim, this.doente];
                }

                this.objTimeline.sort(ordenarPorTimestamp)

                this.loading = false;
            
            })
            .catch((err) => {
                console.log("ERRO AO CONSULTAR DIÁRIO: ", err);
                this.loading = false;
                this.resumo = false;
                alert("Erro ao consultar diário.")
            })
        }
        
        
    },
    mounted() {
        // Log do sistema
        if(userProperties.escolaID != null){            
            // timestamp
            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
            var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
            var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var customtimestamp = year + month + day + hour + minute + second

            db.collection('log_' + userProperties.escolaID).add({
                    escolaID: userProperties.escolaID,
                    slugAutor: userProperties.slug,
                    perfil: userProperties.perfil,
                    
                    //slug: this.slug,
                    customtimestamp: customtimestamp,
                    dia: day,
                    mes: month,
                    ano: year,
                    acao: "acessar",
                    categoria: "dashboard",
                    pontos: 4
                    
                })
                .then(docRef => {
                    console.log('Document written with ID: ', docRef.id);

                    
                })
                .catch(function (error) {
                    console.log('Error adding document: ', error);
                    console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                })
        }
        else{
            alert("Sua sessão expirou, você será redirecionado para reautenticar!");
            this.$router.push(`/`);
        };
    }
    
    
        
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:42%;
        z-index: 2;
    }

    .container{
        padding: 0 1px !important;
    }

    .buttonOk{
        position: absolute;
        right: 2px;
        bottom: 5px;
    }

    .btCirculo{
        height: 30px;
        width: 30px;
    }

    .btCirculo a{
        color:#fff;
    }

    progress{
        width:100%;
        margin-top: 6px;
    }

    label.v-label.theme--light{
        margin-bottom: 6px;
        display: block
    }

    .adicionarItem.btCirculo{
        position: relative;
        top: 12px;
        left: 5px;
    }

    .excluirItem.btCirculo{
        position: relative;
        left: 5px;
        top:-10px;
    }

    .box-items-selecionados{
        background: silver;
        width: 100%;
        padding: 20px 5px 5px 10px;
    }

    .container{
        padding: 0 0 !important;
    }

    .grid-list-sm img{
        width: 70%;
        height: auto !important;
    }

    .grid-list-sm a{
        min-height: 70px;
    }

    a.selected img{
        width: 100%;
        height: auto !important;
        cursor: pointer;
    }

    .label-rating{
        display: block;
        text-align: center
    }

    a.closeModal{
        color: #000;
        position: absolute;
        right: 14px;
        top: 4px;
        font-size: 16px
    }

    .v-avatar{
        position: absolute;
        left: -70px;
        top: 0px;
    }

    .ct-chart{
        text-align: center
    }

    .ct-chart .imgDiario{
        width:25%;
        margin:28px auto 6px auto;
    }

    .ct-chart .imgResumoMensal{
        width:50%;
        margin:33px auto 6px auto;
    }
    
</style>
